import { ArrowUpRight, BookOpen, Images } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="qn-seccion" aria-label={seccion.titulo}>
      <div className="qn-seccion-interior">
        <EncabezadoSeccion p="qn" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="qn-titulo-enlaces" />
        <Reveal>
          <div className="qn-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="qn-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`qn-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "qn-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "qn-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="qn-seccion" aria-label={seccion.titulo}>
      <div className="qn-seccion-interior">
        <EncabezadoSeccion p="qn" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="qn-titulo-accesos" />
        <Reveal>
          <div className="qn-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="qn-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={1.5} />
                <span>
                  <span className="qn-acceso-titulo">{item.datos.titulo}</span>
                  <span className="qn-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { protagonista, evento, legal } = datos;

  return (
    <>
      <Marquee
        p="qn"
        textos={[protagonista.nombre, protagonista.fraseIntroductoria, evento.fechaCorta, evento.ciudad]}
      />
      <section className="qn-seccion qn-cierre" data-testid="qn-cierre">
        <div className="qn-seccion-interior">
          <Reveal>
            {protagonista.insignia && (
              <p className="qn-cierre-insignia" aria-hidden="true">
                {protagonista.insignia}
              </p>
            )}
            <p className="qn-cierre-mensaje">{protagonista.mensajeCierre}</p>
            <p className="qn-cierre-nombre">{protagonista.nombre}</p>
            <div className="qn-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="qn-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="qn-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
